import React from "react";
import {
  Container,
  ContainerText,
  ContainerCarousel,
  ContainerCard,
  Img,
  ContainerDesktop,
} from "./style.js";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Addidas from "../../img/adidas.png";
import banco from "../../img/banco.png";
import hyundai from "../../img/hyundai.png";
import mapfre from "../../img/mapfre.png";
import delta from "../../img/delta.png";
import sy from "../../img/sy.png";
import { useTranslation } from "react-i18next";
import { useScroll } from "../../context/UseContextScroll.js";

const Slider = () => {
  const [t] = useTranslation("global");
  const { mobile } = useScroll();

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 6,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 3,
      slidesToSlide: 1,
    },
  };
  const arrayImg = [
    { id: 1, img: Addidas },
    { id: 2, img: banco },
    { id: 3, img: hyundai },
    { id: 4, img: mapfre },
    { id: 5, img: delta },
    { id: 6, img: sy },
  ];

  return (
    <Container>
      <ContainerText>
        <h1>{t("titleEdition.titleEdition")}</h1>
        <p>{t("textEdition.textEdition")}</p>
      </ContainerText>
      <ContainerCarousel>
        <Carousel
          swipeable={false}
          draggable={false}
          showDots={false}
          responsive={responsive}
          ssr={true} // means to render carousel on server-side.
          infinite={true}
          autoPlay={mobile ? true : false}
          autoPlaySpeed={1500}
          keyBoardControl={true}
          customTransition="all .8s ease-in-out"
          transitionDuration={500}
          containerClass="carousel-container"
          removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}
          itemClass="carousel-item-padding-40-px"
        >
          <ContainerCard>
            <Img adidas="true" src={Addidas} alt="adidas" />
          </ContainerCard>
          <ContainerCard>
            <Img banco="true" src={banco} alt="banco" />
          </ContainerCard>
          <ContainerCard>
            <Img src={hyundai} alt="hyundai" hyundai="true" />
          </ContainerCard>
          <ContainerCard>
            <Img src={mapfre} alt="mapfre" mapfre="true" />
          </ContainerCard>
          <ContainerCard>
            <Img src={delta} alt="delta" delta="true" />
          </ContainerCard>
          <ContainerCard>
            <Img src={sy} alt="sy" sy="true" />
          </ContainerCard>
        </Carousel>
      </ContainerCarousel>
      <ContainerDesktop>
        {arrayImg.map((item) => (
          <ContainerCard key={item.id}>
            <Img src={item.img} alt="img" />
          </ContainerCard>
        ))}
      </ContainerDesktop>
    </Container>
  );
};

export default Slider;
